export default {
    version: 1
};